import type { JSX } from "react";

import { Pill, type PillProps } from "@mantine/core";

interface HandoffTagProps extends PillProps {
    type?: "default" | "warning";
}
export function HandoffTag({ children, type = "default", ...rest }: HandoffTagProps): JSX.Element {
    return (
        <Pill
            bg={type === "warning" ? "warning.5" : "primary.2"}
            c="var(--mantine-color-black)"
            fw={700}
            fz="xs"
            p="0 .1875rem"
            radius={2}
            size="xs"
            w="fit-content"
            {...rest}
        >
            {children}
        </Pill>
    );
}
